import { render } from "./UploadMultipleFiles.vue?vue&type=template&id=09490978&scoped=true"
import script from "./UploadMultipleFiles.vue?vue&type=script&lang=js"
export * from "./UploadMultipleFiles.vue?vue&type=script&lang=js"

import "./UploadMultipleFiles.vue?vue&type=style&index=0&id=09490978&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09490978"]])

export default __exports__